var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('Spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.$loading.isShow),expression:"$loading.isShow"}],class:{'preloader-overlay--white': _vm.$loading.isWhite}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }